import React from "react";
import Header from "../Header";
import Dashboard from "../Dashboard/Dashboard";

const Admin = () => {
    return (
        <>
        <Header />
        <Dashboard />
        </>
    )
}


export default Admin;